import React, { lazy } from 'react';

function Splash() {
     const origin = window.location.hostname
    .replace(/^www\./, '')
    .replace(/\.(com|live|net|bet|buzz|win|world)$/i, '');
    const [imageError, setImageError] = React.useState(false);

    const handleImageError = () => {
        setImageError(true);
    };

    return (
        <div className="splash-screen">
            {imageError ? (
                <div className="three-dots-loading">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            ) : (
                <img
                    src={`./splash/${origin}.gif`}
                    onError={handleImageError}
                    onLoad={lazy}
                    alt="Loading..."
                />
            )}
        </div>
    );
}

export default Splash;
